import { Observable } from 'rxjs';

export abstract class AreYouSureDialog {
  abstract confirm(message: string): Observable<boolean> | Promise<boolean> | boolean;
}

